import React from 'react';
import PropTypes from 'prop-types';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';

import {
  BtnPurpleTransparent32,
  BtnGreen32
} from 'components/common/Elements/Elements';

import classes from './AlertDelGroup.module.scss';

const AlertDelGroup = ({ handleCancel, handleDel }) => {
  const language = useUserState().user.language;

  return (
    <div className={classes.bodyAlert}>
      <BtnPurpleTransparent32
        onClick={handleCancel}
        textButton={t('alertDelGroup', 'CANCEL', language)}
        className={classes.btnCancel}
      />
      <BtnGreen32
        onClick={handleDel}
        textButton={t('alertDelGroup', 'DELETE', language)}
      />
    </div>
  );
};

export default AlertDelGroup;

AlertDelGroup.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleDel: PropTypes.func.isRequired
};
